import React, { Component } from 'react';
import { Route, Routes } from 'react-router';
import { Layout } from './components/Layout';
import { RatesAndAvailability } from './components/RatesAndAvailability';
import  Home  from './components/Home';
import Load from './components/Load';
import './custom.css';


export default class App extends Component {
    constructor(props) {
        super(props);
        this.state = { property: '', promotions: [], roomTypes: [], closedDates: [] };
    }
    static displayName = App.name;

    setProperty(property) {

        this.setState({ property: property });
        
    }    

    setPromotions(promotions) {

        this.setState({ promotions: promotions });

    } 

    setRoomTypes(roomTypes) {
        this.setState({ roomTypes: roomTypes})
    }

    setClosedDates(closedDates) {
        this.setState({ closedDates: closedDates})
    }

    render () {
    return (
        <Layout>
            <Routes>
                <Route path=':propertyName' element={<Load
                        
                        //setProperty={(property) => this.setProperty(property)}
                        //setPromotions={(promotions) => this.setPromotions(promotions)}
                        //setRoomTypes={(roomTypes) => this.setRoomTypes(roomTypes)}
                        //setClosedDates={(closedDates) => this.setClosedDates(closedDates)}
                    />}>
                    
               </Route>
                <Route path='/RatesAndAvailability' element={<RatesAndAvailability
                        //propertyId={this.state.property.id}
                        //propertyKey={this.state.property.key}
                        //promotions={this.state.promotions}
                        //roomTypes={this.state.roomTypes}
                        //closedDates={this.state.closedDates}
                                        
                    />}>
                    
                </Route>
                <Route path='/Home' element={<Home property={this.state.property}  />}>  </Route>
            </Routes>
        </Layout>
    );
    }
}
